// extracted by mini-css-extract-plugin
export var cardIcon = "_8y-4";
export var checkboxCard = "_8y-0";
export var checkboxCardSelected = "_8y-3";
export var disabled = "_8y-1";
export var outerBorder = "_8y-2";
export var spacerMedium = "_8y-7";
export var spacerSmall = "_8y-6";
export var spacerXsmall = "_8y-5";